import * as React from 'react'

interface TimestampDividerProps {
  timestamp: string
  locale?: string
  formatFunction: (timestamp: string, locale?: string) => string
}

/**
 * A centered timestamp divider displayed between messages
 */
export const TimestampDivider: React.FC<TimestampDividerProps> = ({ timestamp, locale = 'vi', formatFunction }) => {
  const formattedTimestamp = formatFunction(timestamp, locale)

  return (
    <div className="flex w-full items-center justify-center my-4 sm:my-6">
      <div className="px-3 py-1 sm:px-4 sm:py-1.5 bg-gray-100 rounded-full">
        <span className="text-xs sm:text-sm text-gray-500 font-medium">{formattedTimestamp}</span>
      </div>
    </div>
  )
}
